import React, { useEffect, useMemo } from "react";
import { useSEO } from "../lib/useSEO";
import { SITE_URL } from "../lib/siteConfig";
import { renderAlcoholContent, landingOptions } from "../lib/alcoholLandingContent";
import { alcoholLandingSchema } from "../lib/alcoholLandingSchema";
import data from "../data/alcoholLanding.json";
import "./alcohol-landing.css";

export default function AlcoholLanding() {
  const options = useMemo(() => ({ siteOrigin: SITE_URL, apiOrigin: process.env.REACT_APP_BACKEND_URL,
    phone: process.env.REACT_APP_CONTACT_PHONE, whatsapp: process.env.REACT_APP_WHATSAPP_URL }), []);
  const content = useMemo(() => renderAlcoholContent(options), [options]);
  const hero = useMemo(() => landingOptions(options).hero, [options]);
  useSEO({ title: data.title, description: data.description, path: data.path, image: hero, imageAlt: data.imageAlt });
  useEffect(() => {
    const base = document.getElementById("base-seo-schema");
    const backup = document.getElementById("alcohol-base-schema-backup");
    const baseText = base?.textContent || backup?.textContent;
    base?.remove();
    backup?.remove();
    const id = "alcohol-landing-schema";
    const script = document.getElementById(id) || document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(alcoholLandingSchema(options)).replace(/</g, "\\u003c");
    if (!script.isConnected) document.head.appendChild(script);
    return () => {
      script.remove();
      if (baseText && !document.getElementById("base-seo-schema")) {
        const restored = base || document.createElement("script");
        restored.id = "base-seo-schema";
        restored.type = "application/ld+json";
        const identity = JSON.parse(baseText);
        identity["@graph"] = identity["@graph"].filter((node) => node["@type"] !== "FAQPage");
        restored.textContent = JSON.stringify(identity).replace(/</g, "\\u003c");
        document.head.appendChild(restored);
      }
    };
  }, [options]);
  return <div data-testid="alcohol-route" dangerouslySetInnerHTML={{ __html: content }} />;
}